export const formSubmitValueMapper = (data = {}) => ({
  id_maintenance_request_master: data.id_maintenance_request_master,
  tgl_maintenance_request_master: data.tgl_maintenance_request_master,
  catatan: data.catatan,
  detail: data.detail.map((val) => ({
    id_item_aset: val.idItemAset,
    keterangan: val.keterangan,
  })),
});
